import {
  ProjectDropdownItem,
  ProjectSortByEnum,
  ProjectSummary,
  Project,
  ProjectsTableRow,
} from "./types";
import { fromCompanyToRequestingCompany } from "../Form/helpers";

export const mapProjectsResponseToRows = (
  projects: ProjectSummary[]
): ProjectsTableRow[] => {
  return projects.map((project) => {
    return {
      name: project.project.name,
      id: project.project.id,
      requestingCompany: fromCompanyToRequestingCompany(
        project.project.requesting_company
      ),
      total:
        project.gas_request_summary.total +
        project.electricity_request_summary.total,
      drafts:
        project.gas_request_summary.drafts +
        project.electricity_request_summary.drafts,
      submitted:
        project.gas_request_summary.lodged +
        project.electricity_request_summary.lodged,
      lodged:
        project.gas_request_summary.lodged +
        project.electricity_request_summary.lodged,
      book_closure:
        project.gas_request_summary.book_closure +
        project.electricity_request_summary.book_closure,
      finished:
        project.gas_request_summary.finished +
        project.electricity_request_summary.finished,
      stalled:
        project.gas_request_summary.new_message +
        project.electricity_request_summary.new_message,
      status: project.status,
      projectRaw: project,
    };
  });
};

export const mapProjectsTableRowKeyToSortByEnum = (
  key: keyof ProjectsTableRow
): ProjectSortByEnum | null => {
  const keyToSortByEnumMap: Partial<
    Record<keyof ProjectsTableRow, ProjectSortByEnum>
  > = {
    name: ProjectSortByEnum.NAME,
    status: ProjectSortByEnum.STATUS,
  };

  return keyToSortByEnumMap[key] || null;
};

export const mapProjectsToDropdownItems = (
  projects: Project[]
): ProjectDropdownItem[] => {
  return projects.map((p) => ({ label: p.name, value: p.id }));
};
